<template>
    <b-container fluid v-if="value" class="p-0" @click="onSelect">
        <div class="d-flex flex-row orderContainer border-bottom" :class="{'selected' : viewingOrder && value ? viewingOrder._id === value._id : false }">                                
            <b-img-lazy :src="statusImage"
                         class="icon" />
            <div class="full-width">
                <div class="d-flex full-width">
                    <span class="flex-grow-1 left">{{value.name}}</span>
                    <span class="right">#{{value.orderNumber}}</span>
                </div> 
                <div class="d-flex full-width">
                    <span class="flex-grow-1 left">{{displayDate}}</span>
                    <span class="right" v-if="elapseTime > 0" :style="styleEstimateTime">{{timeFormat(elapseTime)}}</span>
                </div> 
                <div class="d-flex full-width">
                    <span class="flex-grow-1 left">{{value.items.length}} Items</span>
                    <span class="right">{{$c2d(value.total) | currency}}</span>
                </div> 
            </div>
        </div>
    </b-container>
</template>

<script>

import { mapState } from 'vuex'
const DISPLAY_DATE_TIME_FORMAT = "MM/D hh:mma"

export default {
    components : {
    },
    props : {
        value : { type : Object },
    },
    computed : { 
		...mapState({
            viewingOrder:"viewingOrder"
		}),
        getOS() {
            return this.$store.getters.getOrderStatus
        },
        timeZone() {
            return this.$store.getters.timeZone
        },
        statusImage() {
            return require(`@/assets/images/${this.status.icon}.png`)
        },
        orderTime() {
            return this.value.orderTime;
        },
        startTime() {
            return this.value.startTime;
        },
        timeEstimate() {
            return this.value.timeEstimate;
        },
        completeTime() {
            return this.value.completeTime;
        },

        status() {
            return this.getOS[this.value.status];
        },

        styleEstimateTime() {
            let style = {}
            if(this.completeTime) {
                style.color = "#000"
            } else {
                let diffEstimateTime = this.estimateTime()
                if (!diffEstimateTime || diffEstimateTime > 2 * 60 * 1000) {
                    style.color = "#000000"
                } else if (diffEstimateTime >= 0 && diffEstimateTime <= 2 * 60 * 1000) {
                    style.color = "#FF9800"
                } else if (diffEstimateTime < 0) {
                    style.color = "#F06292"
                }
            }
            return style
        },
        displayDate() {
            return this.moment(this.orderTime).tz(this.timeZone).format(DISPLAY_DATE_TIME_FORMAT);
        }

    },
    data() {
        return {
            timer : '',
            elapseTime : 0
        }
    },
    watch : {

    },
    mounted() {
        this.$nextTick(() => {	
        })
    },
    created() {
        this.timer = setInterval(this.updateElapsedTime, 1000)
    },
    destroyed() {

    },
    methods: {    
        cancelAutoUpdate () { clearInterval(this.timer) },    
        estimateTime(){
            return this.moment(this.timeEstimate).tz(this.timeZone).diff(this.moment().tz(this.timeZone))
        },
        updateElapsedTime() {
            let millis = 0;
            if (this.completeTime && this.startTime) {
                millis = this.moment(this.completeTime).diff(this.moment(this.startTime));
            } else if (!(this.status === this.getOS.Cancelled_Customer || this.status  === this.getOS.Cancelled_Staff || this.status === this.getOS.Rejected)) {
                millis = this.moment().tz(this.timeZone).diff(this.moment(this.orderTime).tz(this.timeZone));
            } else {
                this.cancelAutoUpdate()
            }
            this.elapseTime = millis;
            // let dateDiff = this.dateDiff(this.moment.duration(this.moment().diff(this.moment(this.orderTime))))
        },
        timeFormat(millis) {
            let d = this.moment.duration(millis);
            let mins = Math.floor(d.asMinutes());
            let seconds = Math.floor(d.asSeconds()) - mins * 60;
            return `${this.$zeroPad(mins, 10)}:${this.$zeroPad(seconds, 10)}`
        },
        onSelect() {
            this.$store.commit('selectViewingOrder', this.value)
            this.$emit("on-order-click", this.value)
        }
    },
    beforeDestroy () {
      clearInterval(this.timer)
    }
}
</script>


<style scoped>
    div.orderContainer {
        background: rgb(243, 243, 243);
        padding: 0px 5px;
        cursor: pointer;
    }
    div.orderContainer:hover {
        background: rgb(220, 220, 220);
        padding: 0px 5px;
        cursor: pointer;
    }
    div.selected {
        background: rgb(220, 220, 220);
    }
    img.icon {
        width: 66px;
        height: 66px;
        padding: 5px;
        margin: auto;
    }
    div.full-width {
        width: 100%;
    }

    span.left {

    }
    span.right {

    }
</style>